export default function(input) {
  return {
    price: {
      amount: Number(input.price.amount), // number
      currency: input.price.currency, // string
    },
  }
}
